import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {

    findAllMissionAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/mission/find-all`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    storeMissionAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/mission/store`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateMissionAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/mission/update`, payload)
          .then((res) => {
            resolve(res.data.mission);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteMissionFileAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/mission/delete-file`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteMissionAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/mission/delete-mission`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
